import { FC } from 'react';
import { AnalyticsCommonTypes } from '@frontend/api-analytics';
import { GroupedCheckListDropdownMenu } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { useVoiceAiLocations } from '../../../hooks/use-voice-ai-locations';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';
import { FilterTraySection } from '../filter-tray-section/filter-tray-section';
import { useOfficeUserFilterData } from './use-office-user-filter-data';

export interface OfficeUserFilterTrayProps {
  disabled?: boolean;
  officeUsers?: AnalyticsCommonTypes.StringRecord;
  showClear?: boolean;
}

export const OfficeUserFilterTray: FC<OfficeUserFilterTrayProps> = ({ disabled, officeUsers, showClear = true }) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues } = useCallIntelFiltersContext();

  const { activeLocationIds: activeVoiceAiLocations, isLoading: isVoiceAiLoading } = useVoiceAiLocations({
    locationIds: filterValues.locations ?? [],
  });

  const {
    value: selectedValues,
    groupedOfficeUsers,
    hasOptions,
    isLoading,
    onChange,
  } = useOfficeUserFilterData({
    officeUsers,
    showAiReceptionist: activeVoiceAiLocations.length > 0,
  });

  const isDisabled = disabled || isLoading || isVoiceAiLoading;

  if (!hasOptions) {
    return null;
  }

  return (
    <FilterTraySection
      label={t('Office User')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <GroupedCheckListDropdownMenu
        name='office-users'
        label={t('Select Office User')}
        placeholder={t('Select Office User')}
        onChange={onChange}
        groups={groupedOfficeUsers}
        trackingIdBase={trackingIds.callIntel.officeUsersFilter}
        value={selectedValues}
      />
    </FilterTraySection>
  );
};
